var urlString = "https://admin.hideindia.com/hide-api/";
// var urlString = "http://localhost:8094/hide-api/";

const GetApiCall = {
  getRequest(url) {
    console.log(urlString + url);
    return fetch(urlString + url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json",
      },
    });
  },
};

export default GetApiCall;
